var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIgne(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    rx: 13,
    fill: "#00846E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_305_19473)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6.67357V19.2917H11.5277V12.9867V6.67357H6.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4796 12.9867L18.9441 10.7198C19.3122 10.1511 19.4923 9.63919 19.4923 8.99731C19.4923 7.67294 18.4664 6.51106 17.0098 6.51106C15.9995 6.51106 15.2712 7.00669 14.6447 8.01419L11.5278 12.9867L14.6447 17.9592C15.2712 18.9667 15.9995 19.4623 17.0098 19.4623C18.4664 19.4623 19.4923 18.3004 19.4923 16.9761C19.4923 16.3342 19.3122 15.8223 18.9441 15.2536L17.4796 12.9867Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_305_19473"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(6.5 6.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIgne);
export default __webpack_public_path__ + "static/media/igne.30e19f8818dd73d76109296f63cf257d.svg";
export { ForwardRef as ReactComponent };